import { OrgSiteListEntry } from "@inrange/building-manager-api-client/models-organisation";
import { Site } from "@inrange/building-manager-api-client/models-site";
import { SelectFilterOption } from "@inrange/theme-components";

export const getLatestActualsMonthIndex = (
  site: Site | OrgSiteListEntry
): number | undefined => {
  for (let i = site.energyFinancialsMonthly.length - 1; i >= 0; i--) {
    const energyFlowActuals = site.energyFinancialsMonthly[i];
    if (energyFlowActuals.energy.actual) {
      return i;
    }
  }
  return undefined;
};

export const sortOwnershipSelectOptions = (
  options: SelectFilterOption[]
): SelectFilterOption[] => {
  return options.sort((a, b) => {
    if (a.label === "Undefined") return 1;
    if (b.label === "Undefined") return -1;
    return a.label.localeCompare(b.label);
  });
};
